import { request } from "@/utils/request";

/**
 * 获取手机验证码
 * @param {
 *  mobile: 手机号,
 *  countryCode: '86' 国家代码
 * } data
 */
export const getMobileCodeApi = (data) => {
  return request.post("/api/ucenter/sendVerifyCode", data);
};

/**
 * 手机号登录
 * @param {
 *  mobile: 手机号,
 *  code: 验证码
 * } data
 */
export const mobileLoginApi = (data) => {
  return request.post("/api/login/mobileLogin", data);
};

/**
 * 获取邮箱验证码
 * @param {
 *  email: 邮箱,
 * } data
 */
export const getEmailCodeApi = (data) => {
  return request.post("/api/email/verifyCode", data);
};

/**
 * 邮箱登录
 * @param {
 *  email: 邮箱,
 *  code: 验证码
 * } data
 */
export const emailLoginApi = (data) => {
  return request.post("/api/login/emailLogin", data);
};
